import {baseDevConfig} from '../base/dev.config';
import {cbsnewsLocalConfig} from './local.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbsnewsDevConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseDevConfig, cbsnewsLocalConfig,  {
  environmentName: "Cbs News Development Environment",
  hubApi: "https://testcms.cbsnews.com",
  ionicEnvName: 'dev',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbsnews/dev.config.ts